import React, { FunctionComponent, useState } from 'react'
import * as yup from 'yup'
import useFormal from '@kevinwolf/formal-web'
import { SubmitButton } from 'Elements/SubmitButton'
import Grid from '@material-ui/core/Grid'
import { useCustomerNotificationExclusions } from 'components/views/customer-notification-exclusions/CustomerNotificationExclusionsProvider'
import { useTranslation } from 'react-i18next'
import { PlateNumberField } from 'Elements/PlateNumberField'
import { TextField } from 'Elements/TextField'
import SearchIcon from '@material-ui/icons/Search'
import AddCustomerNotificationExclusionDialog from 'CustomerNotificationExclusions/partials/AddCustomerNotificationExclusionDialog'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import AddIcon from '@material-ui/icons/Add'

export type Props = {}
export type Functions = {}
export type AllProps = Props & Functions

const Toolbar: FunctionComponent<AllProps> = ({}) => {
  const { t } = useTranslation()
  const { filter, listLoading, onFilter } = useCustomerNotificationExclusions()

  const [openAddCustomerNotificationExclusionDialog, setOpenAddCustomerNotificationExclusionDialog] = useState(false)

  const schema = yup.object().shape({
    mobillyClientId: yup.lazy(value =>
      value === ''
        ? yup.string()
        : yup.number().integer().min(1),
    ),
    plateNumber: yup.string().uppercase(),
  })

  const formal = useFormal(filter, {
    schema,
    onSubmit: async values => {
      if (listLoading) {
        return
      }

      onFilter(schema.cast(values))
    },
  })

  return (
    <>
      <Box marginTop={1} marginBottom={2}>
        <Button
          variant="contained"
          color="primary"
          size="medium"
          startIcon={<AddIcon />}
          onClick={() => setOpenAddCustomerNotificationExclusionDialog(true)}
        >
          {t('newExclusion')}
        </Button>
      </Box>
      <form {...formal.getFormProps()}>
        <Grid container spacing={1} style={{ padding: '16px 0' }}>
          <TextField
            GridProps={{ xs: 6, md: true }}
            type="number"
            label={t('mobillyClientId')}
            size="small"
            inputProps={{
              min: 1,
            }}
            {...formal.getFieldProps('mobillyClientId')}
          />
          <PlateNumberField
            GridProps={{ xs: 6, md: true }}
            clearable={true}
            allowAsterisk={true}
            helperText={<><span style={{fontFamily: '"Roboto Mono", monospace'}}>*</span> {`— ${t('allPlateNumbers')}`}</>}
            size="small"
            {...formal.getFieldProps('plateNumber')}
          />
          <SubmitButton
            GridProps={{ xs: 12, md: 'auto' }}
            buttonText={t('search')}
            startIcon={<SearchIcon />}
            disabled={listLoading}
            style={{height: '40px'}}
          />
        </Grid>
      </form>
      <AddCustomerNotificationExclusionDialog open={openAddCustomerNotificationExclusionDialog} setOpen={setOpenAddCustomerNotificationExclusionDialog} />
    </>
  )
}

export default Toolbar
